export default {
  survey: {
    restartSurvey: 'Start a new survey',
    sendingSurvey: 'Submitting your survey. Please wait…',
    sending: 'Sending...',
    checkoutError: 'There was a problem submitting your form, please try again',
    errorSending: 'We’re sorry, we were unable to submit your survey. Please check your connectivity and try again.',
    retryBtnText: 'Retry',
    doneBtnText: 'Done',
    uploadImage: 'Upload photo',
    submitFeedback: 'Submit Feedback'
  }
};